// function fetchCollectionItems(handle) {
//     $.ajax({
//         url: '/collections/' + handle, 
//         method: 'GET',
//         success: function(response) {
//             var $response = $('<div>').html(response);
            
//             // Update collection items
//             var newItems = $response.find('#collection-items-container').html();
//             $('#collection-items-container').html(newItems);

//             // Update title
//              var newTitle = $response.find('.collection-banner__inner h1.collection-banner__title ').text();
//              $('.collection-banner__inner h1.collection-banner__title ').text(newTitle);

//              // Update Description
//              var newDescrip = $response.find('.collection-banner__description p ').text();
//              $('.collection-banner__description p ').text(newDescrip);


//             // Update breadcrumb title
//              var newBreadcrumbTitle = $response.find('.breadcrumbs .breadcrumbs--last[aria-current="page"]').text();
//              $('.breadcrumbs .breadcrumbs--last[aria-current="page"]').text(newBreadcrumbTitle);

//             // Update image sources
//             var newImage = $response.find('source');
//             $('source').attr('src', newImage.attr('src'));
//             $('source').attr('srcset', newImage.attr('srcset'));

//             var newOverlayImage = $response.find('.image-overlay__image');
//             $('.image-overlay__image').attr('src', newOverlayImage.attr('src'));
//             $('.image-overlay__image').attr('srcset', newOverlayImage.attr('srcset'));
//         },
//         error: function() {
//             alert('Failed to load collection items.');
//         }
//     });
// }


function fetchCollectionItems(handle, filterParams = '') {
    $.ajax({
        url: `/collections/${handle}?${filterParams}`, // Append filter parameters
        method: 'GET',
        success: function(response) {
            var $response = $('<div>').html(response);

            // Update collection items
            var newItems = $response.find('#collection-items-container').html();
            $('#collection-items-container').html(newItems);

            // Update title
            var newTitle = $response.find('.collection-banner__inner h1.collection-banner__title').text();
            $('.collection-banner__inner h1.collection-banner__title').text(newTitle);

            // Update description
            var newDescrip = $response.find('.collection-banner__description p').text();
            $('.collection-banner__description p').text(newDescrip);

            // Update breadcrumb title
            var newBreadcrumbTitle = $response.find('.breadcrumbs .breadcrumbs--last[aria-current="page"]').text();
            $('.breadcrumbs .breadcrumbs--last[aria-current="page"]').text(newBreadcrumbTitle);

            // Update image sources
            var newImage = $response.find('source');
            if (newImage.length) {
                $('source').attr('src', newImage.attr('src'));
                $('source').attr('srcset', newImage.attr('srcset'));
            }

            var newOverlayImage = $response.find('.image-overlay__image');
            if (newOverlayImage.length) {
                $('.image-overlay__image').attr('src', newOverlayImage.attr('src'));
                $('.image-overlay__image').attr('srcset', newOverlayImage.attr('srcset'));
            }
        },
        // error: function() {
        //     alert('Failed to load collection items.');
        // }
    });
}

//Event listener for filter changes
$(document).on('change', '.collection-filter input, .collection-filter select', function() {
    var handle = $('#collection-items-container').data('collection-handle'); // Get collection handle
    var filterParams = $('.collection-filter').serialize(); // Serialize form filters

    // Update collection with the applied filters
    fetchCollectionItems(handle, filterParams);
});

// Retain filter state on page load (optional)
$(document).ready(function() {
    var filterParams = new URLSearchParams(window.location.search).toString(); // Read filter params from URL
    if (filterParams) {
        var handle = $('#collection-items-container').data('collection-handle');
        fetchCollectionItems(handle, filterParams);
    }
});


$(document).ready(function () {
   // Subcollection link click handler
    $(document).on("click", ".link-bar__linklist a.link-bar__link", function (e) {
        e.preventDefault();
        $(".link-bar__linklist a.link-bar__link").removeClass("col_active");
        $(this).addClass("col_active");
        var collectionHandle = $(this).data("collection-handle");
        fetchCollectionItems(collectionHandle);
    });


    // Slider initialization for desktop
    function initializeDesktopSlider() {
        new Swiper(".ctm_quicklinks_slider", {
            slidesPerView: 5.5,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 5.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 50,
                    slidesOffsetBefore: 50,
                },
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
                575: {
                    slidesPerView: 3.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
                375: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
                0: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
            },
        });
    }

    // Slider initialization for mobile
    function initializeMobileSlider() {
        new Swiper(".ctm_quicklinks_mobileslider", {
            slidesPerView: 5,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1280: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 0,
                    slidesOffsetBefore: 0,
                },
                1024: {
                    slidesPerView: 4.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 0,
                    slidesOffsetBefore: 0,
                },
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
                575: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
                375: {
                    slidesPerView: 2.2,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
                0: {
                    slidesPerView: 2.2,
                    spaceBetween: 10,
                    slidesOffsetAfter: 15,
                    slidesOffsetBefore: 15,
                },
            },
        });
    }

    // Check for desktop slider existence and initialize
    var desktopSliderCheckInterval = setInterval(function () {
        if ($(".ctm_quicklinks_slider").length) {
            clearInterval(desktopSliderCheckInterval);
            initializeDesktopSlider();
        }
    }, 100);

    // Check for mobile slider existence and initialize
    var mobileSliderCheckInterval = setInterval(function () {
        if ($(".ctm_quicklinks_mobileslider").length) {
            clearInterval(mobileSliderCheckInterval);
            initializeMobileSlider();
        }
    }, 100);

  
});

// PDP ACCORDIAN 
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".ctm_btn");
  const dropdownContent = document.querySelector(".ctm_pdp_dropdown_content");
  const icon = btn.querySelector(".icon");

  if (btn && dropdownContent && icon) {
    btn.addEventListener("click", function () {
      // Toggle 'active' class on dropdown content
      dropdownContent.classList.toggle("active");

      // Toggle 'active' class on icon
      icon.classList.toggle("active");
    });
  }

});

